module.exports = __webpack_public_path__ + "img/bg-tune-talker.a9bbcfa.svg";